<template>
  <div class="ff">
    <label>{{ name }}</label>
    <input
      :type="type"
      v-if="type != 'select'"
      :id="id"
      :value="modelValue"
      @input="onChange"
      :placeholder="placeholder"
      autocomplete="off"
    />
    <select
      v-if="type == 'select'"
      @input="onChange"
      :id="id"
      :value="modelValue"
      style="text-transform: capitalize"
    >
      <option disabled value="null">{{ placeholder || "Select one" }}</option>
      <option v-for="item in options" v-bind:value="item" v-bind:key="item">
        {{ item.replace("_", " ") }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: "FilterField",
  props: {
    id: String,
    name: String,
    val: String,
    placeholder: String,
    type: String,
    modelValue: String,
    enableInput: Boolean,
    options: Array,
    needBubble: Boolean,
  },
  methods: {
    onChange(e) {
      this.$emit("update:modelValue", e.target.value);
      this.$emit("onUpdate", {
        id: this.id,
        value: e.target.value,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ff {
  width: 100%;
  height: 3rem;
  border: 0.1rem solid #e9ecef;
  color: white;
  border-radius: 2px;
  display: flex;
  align-items: center;
  overflow: hidden;
  background: #e9ecef;

  label {
    color: black;
    margin: 0;
    margin: 0rem 1rem;
  }

  input {
    width: 100%;
    height: 100%;
    background: white;
    margin-left: auto;
    border: none;
    outline: none;
    padding: 1rem;
  }

  select {
    outline: none;
    width: 100%;
    height: 100%;
  }
}
</style>